/**
 * Our mechanism for locking screen orientation.
 */

// Waits for orientation change to actually complete, this is after the orientation change event and resize event.
// where it waits for dimensions to be set on the screen and not being processed.
export const waitOrientationChangeToLandscape = () => {
    const maxIterations = 200;

    return new Promise<void>((resolve) => {
        const waitForOrientationChange = (iteration: number) => {
            if (iteration >= maxIterations) {
                resolve();
                return;
            }

            if (window.innerHeight < window.innerWidth) {
                resolve();
                return;
            }

            window.requestAnimationFrame(function () {
                waitForOrientationChange(iteration + 1);
            });
        };

        waitForOrientationChange(0);
    });
};
